import { SySiteI18n } from './sy-site-i18n';

// TODO: reformar pra usar a config do site que também é usada no language detector
export function getLanguagePath(lang?: any) {
  const language = lang || SySiteI18n.i18n.language;
  switch (language) {
    case 'pt': {
      return '/br';
    }
    case 'en': {
      return '';
    }
    default: {
      return '/' + language;
    }
  }
}
